/* @flow */

import * as React from 'react';

import { aboutPath, aboutContactDetailsPath, privacyPolicyPath } from 'routes';

export type Props = {|
  staticPagesEnabled: boolean
|};

function FooterLinkList(props: { children: React.Node }) {
  return (
    <div className="m-search-results-footer">
      <ul>{props.children}</ul>
    </div>
  );
}

function LinkItem(props: {
  href: string,
  children: React.Node,
  openInNewTab?: boolean
}) {
  return (
    <li>
      <a href={props.href} target={props.openInNewTab ? '_blank' : null}>
        {props.children}
      </a>
    </li>
  );
}

export default function SearchResultFooter(props: Props) {
  if (props.staticPagesEnabled) {
    return (
      <FooterLinkList>
        <LinkItem href={aboutPath()}>
          {__('search.search_results.footer.company')}
        </LinkItem>
        <LinkItem href={aboutContactDetailsPath()}>
          {__('search.search_results.footer.contact')}
        </LinkItem>
        <LinkItem href={privacyPolicyPath()} openInNewTab>
          {__('search.search_results.footer.privacy_policy')}
        </LinkItem>
        <LinkItem href="https://venuu.se" openInNewTab>
          Venuu.se
        </LinkItem>
      </FooterLinkList>
    );
  } else {
    return (
      <FooterLinkList>
        <LinkItem href="https://venuu.se" openInNewTab>
          Venuu.se
        </LinkItem>
        <LinkItem href="https://venuu.fi" openInNewTab>
          Venuu.fi
        </LinkItem>
      </FooterLinkList>
    );
  }
}
